/* Moss & Molt ship-day link on Neocaridina product pages (moved out of snippets/mm-header-custom.liquid, audit #13, Oct 29 2026). Loaded with defer only where the ship-day box is rendered. */
(function () {
  function place() {
    var anchor = document.querySelector('.product-form-buttons');
    if (!anchor || document.querySelector('.mm-ship-day')) return;
    var el = document.createElement('p');
    el.className = 'mm-ship-day';
    el.innerHTML = '<a class="mm-ship-day__go" href="/pages/shipping"><svg viewBox="0 0 7 7" aria-hidden="true"><path d="M0 1h7v1H0zM1 2h5v1H1zM2 3h3v1H2zM3 4h1v1H3z" fill="currentColor"/></svg>' +
      '<span>Enter your zip code to check weather <strong>HERE</strong></span></a>';
    el.firstChild.addEventListener('click', function (e) {          // slides down to the weather check on this page
      var box = document.querySelector('.mm-swc');
      if (!box) return;                                              // no checker on this page: the link opens the Shipping page
      e.preventDefault();
      var still = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      box.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'start' });
      var inp = box.querySelector('.mm-swc__input');
      if (inp) setTimeout(function () { try { inp.focus({ preventScroll: true }); } catch (x) {} }, still ? 0 : 700);
    });
    anchor.parentNode.insertBefore(el, anchor);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', place); else place();
})();
